module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "m-boxInfo__title"
  }, [_vm._v("Next steps:")]), _vm._v(" "), _c('div', {
    staticClass: "m-boxInfo--container"
  }, [_c('ol', {
    staticClass: "m-boxInfo--steps"
  }, _vm._l((_vm.steps), function(step, index) {
    return _c('li', {
      key: index,
      staticClass: "m-boxInfo--steps__step"
    }, [_c('span', {
      staticClass: "m-boxInfo--steps__step__text",
      domProps: {
        "innerHTML": _vm._s(step.message)
      }
    })])
  }), 0), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "m-boxInfo__myAccount"
  }, [_vm._v("\n      You can manage your products, view billing history, \n      update payment methods and manage devices in\n      "), _c('a', {
    staticClass: "a-Link--Blue",
    attrs: {
      "href": "https://account.serato.com/#/"
    }
  }, [_vm._v("\n        My Account.\n      ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-092dda8c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/checkout/components/molecules/BoxInfo.vue
// module id = 521
// module chunks = 2